import '../../assets/styles/pages.scss'
import { Link, useLocation, useMatch, useNavigate } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import henceforthApi from '../../utils/henceforthApi'
import { sellerlist } from '../../context/interfaces'
import PaginationLayout from '../../components/PaginationLayout'
import { GlobalContext } from '../../context/Provider'
import profile_placeholder from '../../assets/images/pages/profile_placeholder.png'
import BreadCrumb from '../../components/common/BreadCrumb'
import Spinner from '../../components/BootstrapCompo'
import { INSUFFICIENT_PERMISSIONS } from '../../context/actionTypes'

const SellerRequestListing = () => {

    let breadCrumbPath = [
        { name: 'Home', url: `/`, active: '' },
        { name: 'Seller Requests', url: ``, active: 'not-allowed' }
    ]

    const match = useMatch("seller-requests/:page")
    const location = useLocation()
    const newParam = new URLSearchParams(location.search);
    const { authState, onChangePagination } = useContext(GlobalContext);
    let limit = 10

    const [totalcount, setTotalCount] = useState(0)
    const [search, setSearchData] = useState("")
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [state, setstate] = useState<sellerlist>()

    const status = newParam.get("status") || "pending";

    const initialise = async () => {
        try {
            setLoading(true)
            let searchData = newParam.get("search") || null;
            let Apires = await henceforthApi.Seller.getsellerrequests(
                searchData,
                status,
                Number(match?.params?.page) - 1,
                limit,
            )
            setstate(Apires)
            setTotalCount(Apires?.total_count || Apires?.data?.length || 0);
        } catch (error: any) {
            if (error?.response?.body?.error === INSUFFICIENT_PERMISSIONS) {
                window.history.back()
            }
        } finally {
            setLoading(false)
        }
    }

    const onSearch = (searchall: any) => {
        const params = new URLSearchParams(location.search)
        if (searchall) {
            params.set("search", searchall)
        } else {
            params.delete("search")
        }
        navigate(`/seller-requests/1?${params.toString()}`)
    }

    const onChangeFilter = (type: string) => {
        const params = new URLSearchParams()
        params.set("status", type)
        navigate(`/seller-requests/1?${params.toString()}`)
    }

    useEffect(() => {
        initialise()
    }, [match?.params?.page, location.search, authState?.lang])

    return (
        <>
            <BreadCrumb pathNameDeclare={breadCrumbPath} />

            <div className='page-spacing'>
                <section className='product-listing'>
                    <div className="container-fluid px-xs-0">
                        <div className='common-card mb-4 border-0 card-spacing'>
                            <div className="row justify-content-between gy-3">
                                <div className="col-md-7">
                                    <div className="row gy-3">
                                        <div className="col-sm-7 col-md-7">
                                            <div className='form-fields-box'>
                                                <label className='mb-1 form-label fw-semibold'>Search</label>
                                                <div className='position-relative'>
                                                    <input type="search" className="form-control rounded-0 ps-4 "
                                                        placeholder="Search by Name, Email "
                                                        value={search}
                                                        onChange={(e: any) => {
                                                            setSearchData(e.target.value);
                                                            onSearch(e.target.value)
                                                        }}
                                                    />
                                                    <span className='search-icon'><i className='fa fa-search'></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <h5>Seller Requests</h5>
                                        </div>
                                    </div>
                                    <div className="common-card-content">
                                        <ul className="nav nav-tabs mb-3">
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${status === "pending" ? "active" : ""}`}
                                                    onClick={() => onChangeFilter("pending")}
                                                >
                                                    Pending
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${status === "reject" ? "active" : ""}`}
                                                    onClick={() => onChangeFilter("reject")}
                                                >
                                                    Rejected
                                                </button>
                                            </li>
                                        </ul>

                                        {loading ? <div className='d-flex justify-content-center my-5'><Spinner /></div> :
                                            <>
                                                <div className='data-list-table table-responsive mb-3'>
                                                    <table className="table table-striped align-middle">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr.No.</th>
                                                                <th>Owner Name</th>
                                                                <th>Company Name</th>
                                                                
                                                                <th>Email</th>
                                                                <th>Phone Number</th>
                                                                <th>City</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Array.isArray(state?.data) && state?.data.length ? state?.data.map((res: any, index: any) =>
                                                                <tr key={res._id}>
                                                                    <td>{(Number(match?.params?.page) - 1) * limit + (index + 1)}</td>
                                                                    <td className='product-image-table'>
                                                                        <img src={res.image ? henceforthApi.FILES.imageSmall(res.image) : profile_placeholder} alt="img" className='rounded-circle me-2' /> {res.name ? `${res.name}` : "Not Available"}
                                                                    </td>
                                                                    <td>{res.company ? `${res.company}` : "Not Available"}</td>
                                                                    <td>{res.email ? `${res.email}` : "Not Available"}</td>
                                                                    <td>+{res.country_code}-{res.phone_number ? `${res.phone_number}` : "Not Available"}</td>
                                                                    <td>{res.city ? `${res.city}` : "Not Available"}</td>

                                                                    <td>
                                                                        <Link to={`/seller-request/${res._id}`} className="btn btn-white btn-sm"> <i className='fa fa-eye me-1'></i>View</Link>
                                                                    </td>
                                                                </tr>
                                                            ) : <tr><td colSpan={5} className="text-center py-4">No data found</td></tr>}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className='dashboad-pagination-box'>
                                                    <PaginationLayout
                                                        count={totalcount}
                                                        data={state?.data}
                                                        page={Number(match?.params?.page)}
                                                        limit={Number(limit)}
                                                        onPageChange={(val: any) => onChangePagination(val)}
                                                    />
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
export default SellerRequestListing;
